export default __webpack_public_path__ + "static/media/success.c21f821b.svg";